import { Component, Fragment, useRef, useCallback } from "@wordpress/element";
import { Alert, Space, Tabs } from "antd";

const { TabPane } = Tabs;

const Covid_Fantasy = () => {
    const callback = (key) => {
        console.log(key);
    };

    return (
        <Tabs
            defaultActiveKey="1"
            onChange={callback}
            size="small"
            tabPosition="left"
        >
            <TabPane tab="Overall" key="overall">
                Overall
            </TabPane>
            <TabPane tab="Runs" key="runs">
                Runs Content
            </TabPane>
            <TabPane tab="Stolen Bases" key="stolen_bases">
                Stolen Bases Content
            </TabPane>
            <TabPane tab="Batting Average" key="batting_average">
                Batting Average
            </TabPane>
            <TabPane tab="Home Runs" key="home_runs">
                Home Runs Content
            </TabPane>
            <TabPane tab="RBIs" key="rbis">
                RBIs Content
            </TabPane>
            <TabPane tab="Ks" key="ks">
                Ks Content
            </TabPane>
            <TabPane tab="Wins" key="wins">
                Wins Content
            </TabPane>
            <TabPane tab="Saves" key="saves">
                Saves Content
            </TabPane>
            <TabPane tab="ERA" key="era">
                ERA Content
            </TabPane>
            <TabPane tab="WHIP" key="whip">
                WHIP Content
            </TabPane>
        </Tabs>
    );
};

export default Covid_Fantasy;
